import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto10() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.51 66.15" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path d="M9.86,0H32.44a3.78,3.78,0,0,1,3.1,3.09V26.73h1A4,4,0,0,1,38.89,34a4,4,0,0,1-2.32,6.53,4,4,0,0,1-.69,4.78,4.08,4.08,0,0,1-2.15,1.1,2.32,2.32,0,0,1-.76.32c-1.38,2.47-5.48,8.43-13.28,9.3,0,0-.93,1.78-1.19,2.15l3.32,1.63-3.1,6.39L0,57,2.56,51.7l1.62-3.56L1.75,32.84l.06-.58,5-11.95V3.11A3.76,3.76,0,0,1,9.87,0ZM30.42,46.74H14.11c-.23.37-.48.75-.74,1.12L11.61,46.6a11.38,11.38,0,0,0,2.06-4.44,7.61,7.61,0,0,0-.46-4.37c-.93-2.26-2.76-3.45-4.76-4.68l-1.53-.94,1.55-.91a5.63,5.63,0,0,0,.9-1.38A26.28,26.28,0,0,0,11,26a8.21,8.21,0,0,0,.46-4.38h0a3.5,3.5,0,0,0-1.68-2.38l-.21-.1L8.15,22.65,3.93,32.8l1.52,9.53.92,5.8-.09.61L5,51.54l11.75,5.75a4.07,4.07,0,0,1,.56-1c.75-1.16,1.38-2.33,2.14-2.41a15.25,15.25,0,0,0,11-7.12ZM16,41h9.55a3.92,3.92,0,0,1,.92-1.41,4,4,0,0,1,.84-.63,4,4,0,0,1,.82-5.61,4,4,0,0,1,3.06-6.61h1.52V2.88h-23v14a5.48,5.48,0,0,1,3.92,4.17v0a10.22,10.22,0,0,1-.5,5.56,23.42,23.42,0,0,1-2.53,5.23A11.06,11.06,0,0,1,15.2,37,9.7,9.7,0,0,1,16,41Zm20.32-6.24H31.14a3.25,3.25,0,0,0-1.7.27,1.85,1.85,0,0,0,1,3.38h5.35a1.85,1.85,0,0,0,.45-3.65Zm.21-5.86H31.14a1.86,1.86,0,0,0-1.85,1.86,1.84,1.84,0,0,0,1.4,1.79l5.79.06a1.86,1.86,0,1,0,0-3.71ZM33,40.58H29.29a2,2,0,0,0-1.36.54,1.86,1.86,0,0,0-.55,1.3,1.81,1.81,0,0,0,.56,1.31,1.94,1.94,0,0,0,1.35.54H33a2,2,0,0,0,1.35-.54,1.89,1.89,0,0,0,.55-1.31,1.8,1.8,0,0,0-.55-1.3A2,2,0,0,0,33,40.58Z" />
					<path
						class="cls-1"
						d="M23.17,24.4a5.19,5.19,0,0,1-5.39-4.14H15.6l.62-1.66h1.35V17.36h-2l.62-1.66H18a5.67,5.67,0,0,1,5.8-4,6.21,6.21,0,0,1,3,.72l.1.11-.83,2-.21-.2a3.32,3.32,0,0,0-2.17-.73,3.18,3.18,0,0,0-3.11,2.07h4.66l-.62,1.66H20.16V18.5H24.1l-.62,1.65h-2.8A2.94,2.94,0,0,0,23.58,22a3.94,3.94,0,0,0,2.7-1.14l.1-.1,1.35,2.07-.11.1A7.34,7.34,0,0,1,23.17,24.4Z"
					/>
				</g>
			</g>
		</svg>
	);
}
